import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatDate, formatMoney, formatMoneyShorten, getCurrentTimestamp, roundToTwoDecimals } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdPrint, MdWarning } from "react-icons/md";
import logo from '../assets/logo.png';
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

export default function View({ studentUuid, examCycleUuid }) {

	const appContext = useContext(AppContext);
	

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [classroomUuid, setClassroomUuid] = useState('');
	const [report, setReport] = useState(null);
	const [totalClassroomDebt, setTotalClassroomDebt] = useState(0);
	
	const invoiceRef = useRef(null);

	const printReport = useReactToPrint({
		contentRef: invoiceRef,
		documentTitle: "Report", // optional
	});

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getAllClassrooms(),
		]);
		setReady(true);
	}

	async function getReport() {
		if(classroomUuid) {
			setLoading(true);
			await callApi(
				'get-classroom-debts-report',
				{
					uuid: classroomUuid,
				}
			).then((response) => {
				if(response.status === 1) {
					setReport(response.data);
				} else {
					appContext.tellError(response.msg);
				}
			})
			setLoading(false);
		} else {
			appContext.tellError("Please select classroom");
		}
	}

	function getTotalClassroomDebt() {
		if(report && report.allStudentsWithDebts && report.allStudentsWithDebts.length > 0) {
			let _total = 0;

			for (const _student of report.allStudentsWithDebts) {
				_total += Number(_student.paymentsProfile.totalDebt);
			}

			setTotalClassroomDebt(_total);
		}
	}
	

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		setReport(null);
		setTotalClassroomDebt(0);
	}, [ classroomUuid ])

	useEffect(() => {
		getTotalClassroomDebt()
	}, [ report ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	if (ready) {
		return (
			<div
				className="container"
			>
				<div className="row">

					<div className="col-12 mb-4">
						<h6 className="main-section-title">
							Classroom Debt Report
						</h6>
						<hr/>
					</div>

					

					<div className="col-md-12 col-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">
								
								<div className="mt-3 mb-3">
									<label className="form-label">Select classroom</label>
									<select
										value={classroomUuid}
										onChange={(e) => {
											setClassroomUuid(e.target.value)
										}}
										className="form-control"
									>
										<option value='' ></option>
										{
											(appContext.allClassrooms && appContext.allClassrooms.length > 0) ?
											appContext.allClassrooms.map((item, i) => {
												return (
													<option key={item.id} value={item.uuid} >{item.name}</option>
												)
											})
											:""
										}
									</select>
								</div>

								<div className="mt-3 mb-3 text-end">

									<button
										className="btn btn-padded btn-sm btn-dark btn-rounded"
										onClick={() => {
											getReport();
										}}
									>
										Fetch Report
									</button>

								</div>

							</div>
						</div>
					</div>


					{
						(report) ?
						<div className="col-md-12 col-12 mt-2 mb-2">
							<div className="card">
								<div className="card-body">
									
									<h6
										className="card-title"
									>
										Debts Report
									</h6>

									<div className="text-end">
										<button
											className="btn btn-sm"
											onClick={() => {
												printReport()
											}}
										>
											<MdPrint size={24} />
											Print Now
										</button>
									</div>

									<hr/>

									<div
										className=""
										style={{
											width: "100%",
											overflow: "auto"
										}}
									>

										<div
											style={{
												minWidth: "600px",
												padding: "15px",
												
											}}
											className=""
											ref={invoiceRef}
										>
											
											<div 
												className="row"
											>
												
												<div className="col-6">
													<div className="d-flex">
														<img
															src={logo}
															style={{
																width: "150px",
																flexShrink: 0,
																height: "auto",
															}}
														/>
														<h6
															className="font-bold"
															style={{
																fontSize: "28px",
																wordWrap: "break-word",
															}}
														>
															<span
																style={{
																	textTransform: "uppercase",
																}}
															>
																{appContext.currentSchoolData.name}
															</span>
															

															<span
																className="font-bold d-block"
																style={{
																	fontSize: "12px"
																}}
															>
																Email: {appContext.currentSchoolData.contactEmail}
															</span>
															<span
																className="font-bold d-block"
																style={{
																	fontSize: "12px"
																}}
															>
																Phone: {appContext.currentSchoolData.contactPhone}
															</span>
															<span
																className="font-bold d-block"
																style={{
																	fontSize: "12px"
																}}
															>
																Website: {appContext.currentSchoolData.contactWebsite}
															</span>
															<span
																className="font-bold d-block"
																style={{
																	fontSize: "12px"
																}}
															>
																Address: {appContext.currentSchoolData.contactAddress}
															</span>
														</h6>
													</div>
								
													
												</div>
								
												<div className="col-6">
													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-bold   text-end"
													>
														CLASSROOM DEBTS REPORT
													</h6>
								
													<h6
														style={{
															fontSize: "24px"
														}}
														className="font-bold   text-end"
													>
														{report.classroomData.name}
													</h6>

													

													<h6
														style={{
															fontSize: "12px"
														}}
														className="font-semi-bold   text-end"
													>
														Issuance Date: {formatDate(getCurrentTimestamp())}
													</h6>
													
																	
								
												</div>

												<div className="col-12">
													<hr/>

													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-semi-bold"
													>
														Number of Students with Debts: <span style={{ fontSize: "26px" }} className="font-bold">{report?.allStudentsWithDebts?.length}</span>
													</h6>

													<h6
														style={{
															fontSize: "16px"
														}}
														className="font-semi-bold"
													>
														Total Classroom Debt in TZS: <span style={{ fontSize: "26px"}} className="font-bold">{formatMoney(totalClassroomDebt)}</span>
													</h6>


													<hr/>

													{
														(report.allStudentsWithDebts?.length > 0) ?
														<table className="table table-striped">
															<thead>
																<tr>
																	<th>
																		Student's fullname
																	</th>
																	<th>
																		Student's Debt in TZS
																	</th>
																</tr>
															</thead>

															<tbody>
																{
																	report.allStudentsWithDebts.map((item, i) => {
																		return (
																			<tr key={i}>
																				<td
																					style={{
																						textTransform: "uppercase",
																						fontFamily: "FontSemiBold",
																						cursor: 'pointer',
																					}}
																					onClick={() => {
																						appContext.navTo({
																							item: 'side-view',
																							subItem: 'student-options',
																							extraItem: item.uuid,
																						})
																					}}
																				>
																					{item.firstName} {item.middleName} {item.lastName}
																				</td>
																				<td>
																					{formatMoney(item.paymentsProfile.totalDebt)}
																				</td>
																			</tr>
																		)
																	})
																}
															</tbody>
														</table>
														:
														<h6
															style={{
																fontSize: "14px"
															}}
														>
															No students with debts were found
														</h6>
													}
												</div>
												
											</div>
							
										</div>

									</div>

								</div>
							</div>
						</div>
						:""
					}

					
					

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}